/**
 * Theme Editor Script
 * ------------------------------------------------------------------------------
 * Instead of programmatically registering every javascript file
 * whenever the Theme Editor sends update events, we simply re-execute
 * our js files by re-importing them into the document.
 * This removes admin and ensures all custom scripts are tied to the dom
 * and removes the need to stick to any particular conventions.
 *
 */

const head = document.getElementsByTagName('head')[0];

var debounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
    }, wait);
  };
}

var re_execute_js = debounce(ev => {
  document.querySelectorAll('.ps-scripts').forEach((current_script) => {
    console.log(current_script);

    let script = document.createElement('script');
    let type = 'module';
    let classname = current_script.className;
    let src = `${current_script.src.split('?')[0]}?${Math.round(Math.random() * 1000)}`;
    
    script.type = type;
    script.classList.add(classname);
    script.src = src;

    current_script.remove();

    setTimeout(() => {
      head.appendChild(script);
    }, 100);
    
  });
}, 250)

document.addEventListener('shopify:section:load', re_execute_js);
